/**
 * Eon API
 * The Eon.io REST API
 *
 * AUTOGENERATED: Do not edit the class manually.
 * Instead edit the .mustache file and run `node --run gen-openapi`
 */


export class RedshiftCluster {
  /**
  * The name of the cluster
  */
  'name': string;
  /**
  * The id of the cluster
  */
  'id': string;
  /**
  * The databases in the cluster
  */
  'databases': Array<string>;
  /**
  * The role ARNs in the cluster
  */
  'roleArns': Array<string>;

  static readonly discriminator: string | undefined = undefined;

  static readonly attributeTypeMap: Array<{name: string, baseName: string, type: string, format: string}> = [
    {
      "name": "name",
      "baseName": "name",
      "type": "string",
      "format": ""
    },
    {
      "name": "id",
      "baseName": "id",
      "type": "string",
      "format": ""
    },
    {
      "name": "databases",
      "baseName": "databases",
      "type": "Array<string>",
      "format": ""
    },
    {
      "name": "roleArns",
      "baseName": "roleArns",
      "type": "Array<string>",
      "format": ""
    }  ];

  static getAttributeTypeMap() {
    return RedshiftCluster.attributeTypeMap;
  }

  public constructor() {
  }
}

